<template>
  <div class="personal-center">
    <!-- 页面头部 -->
    <div class="header">
      <div class="header-left" @click="goBack">
        <svg width="35" height="35" viewBox="0 0 24 24" fill="none">
          <path d="M15 18L9 12L15 6" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div class="header-title">个人中心</div>
      <div class="header-right" @click="logout">退出</div>
    </div>

    <!-- 用户信息区域 -->
    <div class="user-info">
      <div class="user-avatar">
        <img :src="getAvatarSrc()" alt="用户头像" />
      </div>
      <div class="user-details">
        <div class="username">{{ userInfo.username || 'adkjk1' }}</div>
        <div 
          class="edit-btn" 
          :class="{ 'disabled': isEditDisabled }"
          @click="handleEditClick"
        >
          {{ isEditingName ? '保存' : '编辑' }}
        </div>
      </div>
    </div>

    <!-- 真实姓名单独区域 -->
    <div class="real-name-section">
      <div class="form-item">
        <div class="form-label">真实姓名</div>
        <div v-if="!isEditingName" class="form-value-right">{{ userInfo.nickname || '未设置' }}</div>
        <input 
          v-else
          v-model="tempNickname" 
          type="text" 
          class="form-input-large" 
          placeholder="请输入真实姓名"
          maxlength="4"
        />
      </div>
    </div>

    <!-- 其他表单字段 -->
    <div class="form-section other-fields">
      <div class="form-item">
        <div class="form-label">手机号码</div>
        <div class="form-action">{{ userInfo.mobile || '' }}</div>
      </div>

      <div class="form-item" @click="goToBankCard">
        <div class="form-label">银行卡</div>
        <div class="form-action"></div>
      </div>

      <div class="form-item" @click="goToChangePassword">
        <div class="form-label">登录密码</div>
        <div class="form-action"></div>
      </div>

      <div class="form-item transaction-spacing" @click="goToSetSecurityCode">
        <div class="form-label">交易密码</div>
        <div class="form-action"></div>
      </div>


    </div>
  </div>
</template>

<script>
import userApi from '@/api/user';

export default {
  name: 'PersonalCenter',
  data() {
    return {
      userInfo: {
        username: '',
        avatar: '',
        nickname: '',
        mobile: '',
        bankCard: '',
        loginPassword: '',
        tradePassword: ''
      },
      // 编辑状态管理
      isEditingName: false,
      tempNickname: ''
    }
  },
  computed: {
    // 判断是否禁用编辑功能
    isEditDisabled() {
      // 如果正在编辑状态，不禁用（允许保存）
      if (this.isEditingName) {
        return false;
      }
      // 如果真实姓名不为空，禁用编辑
      return this.userInfo.nickname && this.userInfo.nickname.trim() !== '';
    }
  },
  mounted() {
    this.getUserInfo();
  },
  methods: {
    // 获取用户信息
    async getUserInfo() {
      try {
        const response = await userApi.userInfo();
        console.log('用户信息接口返回:', response);
        
        // 根据接口返回的实际结构，用户数据在msg字段中
        if (response && response.msg) {
          this.userInfo = {
            ...this.userInfo,
            username: response.msg.username || '',
            avatar: response.msg.avatar || '',
            nickname: response.msg.nickname || '',
            mobile: response.msg.mobile || ''
          };
          console.log('解析后的用户信息:', this.userInfo);
          console.log('真实姓名:', this.userInfo.nickname);
          console.log('是否禁用编辑:', this.isEditDisabled);
        }
      } catch (error) {
        console.error('获取用户信息失败:', error);
      }
    },
    // 获取头像源地址
    getAvatarSrc() {
      if (this.userInfo.avatar) {
        // 如果头像数据已经是完整的data URL格式，直接返回
        if (this.userInfo.avatar.startsWith('data:')) {
          return this.userInfo.avatar;
        }
        
        // 如果已经是完整的URL（包含http或https），直接返回
        if (this.userInfo.avatar.startsWith('http://') || this.userInfo.avatar.startsWith('https://')) {
          return this.userInfo.avatar;
        }
        
        // 如果是相对路径，添加API域名
        const baseURL = 'https://admin.banbashop.cc';
        return baseURL + (this.userInfo.avatar.startsWith('/') ? this.userInfo.avatar : '/' + this.userInfo.avatar);
      }
      // 没有头像时使用默认头像
      return require('@/assets/image/logo.png');
    },
    goBack() {
      this.$router.go(-1);
    },
    logout() {
      // 退出登录逻辑
      console.log('退出登录');
    },
    editProfile() {
      // 编辑个人资料逻辑
      console.log('编辑个人资料');
    },
    changeRealName() {
      // 修改真实姓名逻辑
      console.log('修改真实姓名');
    },
    goToBankCard() {
      // 跳转到银行卡页面
      this.$router.push('/newWithdraw');
    },
    goToChangePassword() {
      // 跳转到修改登录密码页面
      this.$router.push('/changePassword');
    },
    goToSetSecurityCode() {
      // 跳转到设置安全密码页面
      this.$router.push('/setSecurityCode?isTrue=true');
    },
    // 处理编辑按钮点击
    handleEditClick() {
      // 如果禁用状态且不在编辑中，不执行任何操作
      if (this.isEditDisabled && !this.isEditingName) {
        return;
      }
      
      // 根据当前状态执行相应操作
      if (this.isEditingName) {
        this.saveName();
      } else {
        this.startEditName();
      }
    },
    // 开始编辑真实姓名
    startEditName() {
      this.isEditingName = true;
      this.tempNickname = this.userInfo.nickname || '';
    },
    // 保存真实姓名
    async saveName() {
      const name = this.tempNickname.trim();
      
      // 验证姓名
      if (!name) {
        alert('请输入真实姓名');
        return;
      }
      
      // 验证中文姓名格式：2-4个中文字符
      const chineseNameRegex = /^[\u4e00-\u9fa5]{2,4}$/;
      if (!chineseNameRegex.test(name)) {
        alert('请输入2-4个中文字符的真实姓名');
        return;
      }
      
      try {
        const response = await userApi.updateProfile({
          nickname: name
        });
        
        console.log('更新姓名接口返回:', response);
        
        if (response && response.code === 1) {
          // 更新成功
          this.userInfo.nickname = name;
          this.isEditingName = false;
          this.tempNickname = '';
          alert('真实姓名更新成功');
        } else {
          alert(response.msg || '更新失败，请重试');
        }
      } catch (error) {
        console.error('更新真实姓名失败:', error);
        alert('网络错误，请重试');
      }
    }
  }
}
</script>

<style lang="less" scoped>
.personal-center {
  min-height: 100vh;
  background: #050925;
  color: white;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.18rem 0.3rem;
  background: #161936;
  
  .header-left {
    width: 1rem;
    height: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  
  .header-title {
    font-size: 0.48rem;
    font-weight: 500;
    color: white;
  }
  
  .header-right {
    font-size: 0.4rem;
    color: white;
    cursor: pointer;
  }
}

.user-info {
  display: flex;
  align-items: center;
  padding: 0.35rem 0.5rem;
  
  .user-avatar {
    width: 1.6rem;
    height: 1.6rem;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 0.4rem;
    
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  
  .user-details {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    
    .username {
      font-size: 0.45rem;
      color: white;
    }
    
    .edit-btn {
      font-size: 0.4rem;
      color: #ef4444;
      cursor: pointer;
      
      &.disabled {
        color: #666;
        cursor: not-allowed;
        opacity: 0.6;
      }
    }
  }
}

// 真实姓名单独区域样式
.real-name-section {
  padding: 0 0.5rem;
  
  .form-item {
    display: flex;
    align-items: center;
    padding: 0.5rem 0;
    border-bottom: 1px solid rgb(255 255 255);
    
    &:last-child {
      border-bottom: none;
      border-bottom: 1px solid rgb(255 255 255)
    }
    
    .form-label {
      width: 2.2rem;
      font-size: 0.4rem;
      color: white;
    }
    
    .form-value {
      flex: 1;
      font-size: 0.4rem;
      color: white;
      padding-left: 0.3rem;
    }
    
    .form-value-right {
      flex: 1;
      font-size: 0.4rem;
      color: white;
      text-align: right;
      padding-right: 0.3rem;
    }
    
    .form-value-container {
       flex: 1;
       display: flex;
       align-items: center;
       justify-content: space-between;
       
       .form-value {
         font-size: 0.4rem;
         color: white;
       }
       
       .form-action {
         font-size: 0.4rem;
         color: #ef4444;
         cursor: pointer;
       }
     }
     
     .form-action {
       flex: 1;
       font-size: 0.46rem;
       // color: #ef4444;
       cursor: pointer;
       text-align: right;
     }
    
    .form-input-container {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 0.3rem;
      
      .form-input {
        background: #161936;
        border: 1px solid #333;
        border-radius: 0.1rem;
        padding: 0.3rem;
        color: white;
        font-size: 0.4rem;
        outline: none;
        
        &::placeholder {
          color: #999;
        }
        
        &:focus {
          border-color: #ef4444;
        }
      }
      
      .form-buttons {
        display: flex;
        gap: 0.3rem;
        justify-content: flex-end;
        
        .cancel-btn, .save-btn {
          padding: 0.2rem 0.4rem;
          border: none;
          border-radius: 0.1rem;
          font-size: 0.35rem;
          cursor: pointer;
          transition: all 0.3s;
        }
        
        .cancel-btn {
          background: #666;
          color: white;
          
          &:hover {
            background: #777;
          }
        }
        
        .save-btn {
          background: #ef4444;
          color: white;
          
          &:hover:not(:disabled) {
            background: #dc2626;
          }
          
          &:disabled {
            background: #999;
            cursor: not-allowed;
          }
        }
      }
    }
  }
  
  .error-message {
    color: #ef4444;
    font-size: 0.35rem;
    margin-top: 0.2rem;
    padding-left: 2.2rem;
  }
}

.form-section {
  padding: 0 0.5rem;
  margin-top: 60px;
  
  .form-item {
    display: flex;
    align-items: center;
    padding: 0.5rem 0;
    border-bottom: 1px solid rgb(255 255 255);
    
    &:last-child {
      border-bottom: none;
    }
    
    .form-label {
      width: 2.2rem;
      font-size: 0.4rem;
      color: white;
    }
    
    .form-value {
      flex: 1;
      font-size: 0.4rem;
      color: white;
      padding-left: 0.3rem;
    }
    
    .form-action {
      flex: 1;
      font-size: 0.46rem;
      // color: #ef4444;
      cursor: pointer;
      text-align: right;
    }
  }
  
  // 其他字段区域的上边距
  .other-fields {
    margin-top: 60px;
  }
  
  // 交易密码的底部间隔线
  .transaction-spacing {
    border-bottom: 1px solid rgb(255 255 255) !important;
  }
}

.form-input-large {
  flex: 1;
  background: #161936;
  border: 1px solid #333;
  border-radius: 0.1rem;
  padding: 0.4rem 0.5rem;
  color: white;
  font-size: 0.45rem;
  outline: none;
  min-height: 1.2rem;
  
  &::placeholder {
    color: #999;
  }
  
  &:focus {
    border-color: #ef4444;
  }
}
</style>